import Vue from 'vue';
import Vuex from 'vuex';
import practices from './modules/practices';
import auth from './modules/auth';
import dashboard from './modules/dashboard';
// const cloneDeep = require('lodash.clonedeep');

Vue.use(Vuex);

export const storeConfig: any = {
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth,
    practices,
    dashboard,
  },
};

export default new Vuex.Store(storeConfig);